import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Select from 'react-select';
import { Modal } from 'react-bootstrap';

class ScheduleGradeAircraftsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      aircrafts: [],
      open_schedule_grades: [],
      schedule_id: this.props.schedule_id,
      schedule_grade_id: this.props.schedule_grade_id,
      schedule_grade_aircrafts: {},
      staffs_1_diurno: {},
      staffs_1_noturno: {},
      staffs_2_diurno: {},
      staffs_2_noturno: {},
      types: {},
      schedule_grade_aircraft_edit: {},
      schedule: {},
      schedule_grade: {},
      base: {},
      aircraft_id: null,
      fiel_1: null,
      fiel_3: null,
      fiel_2: null,
      fiel_4: null,
      fiel_0: null,
      type: null,
      schedule_grade_aircraft_id: null,
      change_schedule_grade_id: null,
      modal: false,
    };

    this.add = this.add.bind(this);
    this.openModal = this.openModal.bind(this);
    this.edit = this.edit.bind(this);
    this.delete = this.delete.bind(this);
    this.transferGrade = this.transferGrade.bind(this);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && Array.isArray(newProps.aircrafts) && Array.isArray(newProps.open_schedule_grades) && Array.isArray(newProps.schedule_grade_aircrafts)) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        schedule_grade_aircrafts: newProps.schedule_grade_aircrafts,
        open_schedule_grades: newProps.open_schedule_grades,
        aircrafts: newProps.aircrafts,
        schedule: newProps.schedule,
        schedule_grade: newProps.schedule_grade,
        base: newProps.base,
        loaded: 1,
      });
    }
  }
    
  // Adiciono uma aeronave na escala
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      schedule_id: this.props.schedule_id,
      schedule_grade_id: this.props.schedule_grade_id,
      aircraft_id: this.state.aircraft_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/adicionar/aeronave', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }    

  // Adiciono uma aeronave na escala
  openModal(schedule_grade_aircraft_id) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/aeronave/' + schedule_grade_aircraft_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert('', '', 'closed');
        if (responseJson.status === 'success') {
          self.setState({
            modal: true,
            schedule_grade_aircraft_edit: responseJson.data.main,
            type: responseJson.data.main.type,
            fiel_0: responseJson.data.main.fiel_0,
            fiel_1: responseJson.data.main.fiel_1,
            fiel_2: responseJson.data.main.fiel_2,
            fiel_3: responseJson.data.main.fiel_3,
            fiel_4: responseJson.data.main.fiel_4,
            staffs: responseJson.data.staffs,
            staffs_1_diurno: responseJson.data.staffs,
            staffs_2_diurno: responseJson.data.staffs,
            types: responseJson.data.types,
            schedule_grade_aircraft_id: schedule_grade_aircraft_id,
          });
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }    

  // Deleta uma aeronave na escala
  delete(schedule_grade_aircraft_id) {
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa aeronave?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/aeronave/' + schedule_grade_aircraft_id, { method: 'DELETE', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Adiciono uma aeronave na escala
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      schedule_grade_aircraft_id: this.state.schedule_grade_aircraft_id,
      type: this.state.type,
      fiel_0: this.state.fiel_0,
      fiel_1: this.state.fiel_1,
      fiel_3: this.state.fiel_3,
      fiel_2: this.state.fiel_2,
      fiel_4: this.state.fiel_4,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/aeronave/editar/fiel', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // ransfere uma aeronave para outra escala
  transferGrade(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      schedule_grade_aircraft_id: this.state.schedule_grade_aircraft_id,
      change_schedule_grade_id: this.state.change_schedule_grade_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/aeronave/transferir/grade', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({modal: false, schedule_grade_aircraft_id: null, schedule_grade_aircraft_edit: {}});
        self.props.handleAlert('', '', 'open');
        self.props.updateData();
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Adicionar aeronave</h3>
  <hr/>
  <form onSubmit={this.add}>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Aeronave:</label>
          <Select
            className="form-field-name"
            name="aircraft_id"
            value={this.state.aircraft_id}
            searchable={true}
            placeholder={''}
            onChange={this.handleSelectChange.bind(this, 'aircraft_id')}
            options={this.state.aircrafts}
          />    
        </div>
      </div>
       <div className="col-md-6">
        <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> Adicionar aeronave</button>
      </div>
    </div>
  </form>
  <hr/>
  <table className="table table-hover table-stripped table-bordered">
    <thead>
      <tr>
        <th className="text-center">Ações</th>
        <th className="text-center">Frota</th>
        <th className="text-center">Aeronave</th>
        <th className="text-center">Fiel 1ª Quinzena</th>
        <th className="text-center">Fiel 2ª Quinzena</th>
      </tr>
    </thead>
    <tbody>
      {Object.keys(self.state.schedule_grade_aircrafts).map(function(k) {
        return(
          <tr>
            <td style={{width: '7%'}} className="text-center">
              <button onClick={() => {self.openModal(self.state.schedule_grade_aircrafts[k].id)}} className="btn btn-xs btn-primary"><i className="fa fa-fw fa-pencil"></i></button>
              <button onClick={() => {self.delete(self.state.schedule_grade_aircrafts[k].id)}} className="btn btn-xs btn-danger"><i className="fa fa-fw fa-trash"></i></button>
            </td>
            <td style={{width: '6%'}} className="text-center">{self.state.schedule_grade_aircrafts[k].aircraft.aircraft_model.model}</td>
            <td style={{width: '6%'}} className="text-center">{self.state.schedule_grade_aircrafts[k].aircraft.registration}</td>
            <td style={{width: '13%'}} className="text-center">{self.state.schedule_grade_aircrafts[k].fiel_1_name}</td>
            <td style={{width: '13%'}} className="text-center">{self.state.schedule_grade_aircrafts[k].fiel_2_name}</td>
          </tr>
        );
      })}
    </tbody>
  </table>
  <Modal show={self.state.modal} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Edição {self.state.schedule_grade_aircraft_edit.aircraft_name} - {self.state.base.name} - {self.state.schedule.name} - Rev.: {self.state.schedule_grade.number}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal: false, schedule_grade_aircraft_id: null, schedule_grade_aircraft_edit: {}}); self.props.handleAlert('', '', 'open'); self.props.updateData();}}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <h4>Editar dados da frota</h4>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Fiel - 1ª Quinzena:</label>
              <Select
                className="form-field-name"
                name="fiel_1"
                value={this.state.fiel_1}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'fiel_1')}
                options={this.state.staffs_1_diurno}
              />    
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Fiel - 2ª Quinzena:</label>
              <Select
                className="form-field-name"
                name="fiel_2"
                value={this.state.fiel_2}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'fiel_2')}
                options={this.state.staffs_2_diurno}
              />    
            </div>
          </div>
        </div>
        <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Editar</button>
      </form>
      {/* <hr/>
      <h4>Transferir para outra escala</h4>
      <hr/>
      <form onSubmit={this.transferGrade}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Selecione a grade/escala:</label>
              <Select
                className="form-field-name"
                name="change_schedule_grade_id"
                value={this.state.change_schedule_grade_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'change_schedule_grade_id')}
                options={this.state.open_schedule_grades}
                required
              />    
            </div>
          </div>
          <div className="col-md-6">
            <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> Transferir aeronaves</button>
          </div>
        </div>
      </form> */}
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal: false, schedule_grade_aircraft_id: null, schedule_grade_aircraft_edit: {}}); self.props.handleAlert('', '', 'open'); self.props.updateData();}}><i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default ScheduleGradeAircraftsTab;


// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeAircraftsTab.js